import { ReactNode, useEffect, useState } from 'react';
import { TaxRateSetup } from './tax-rate-setup';
import { TaxJurisdictionSetup } from './tax-jurisdiction-setup';
import { TabNav } from '../../components/tab-nav/tab-nav';
import { StickyHeader } from '../../components/sticky-header/sticky-header';
import { TaxLocationSetup } from './tax-location-setup';
import { TaxCategorySetup } from './tax-category-setup';

export const TaxSetup = () => {
  const [tab, setTab] = useState<string>('Tax Codes');

  function getTabContent(tab: string): ReactNode {
    setTab(tab);
    switch (tab) {
      case 'Tax Codes':
        return <TaxRateSetup />;
      case 'Tax Jurisdictions':
        return <TaxJurisdictionSetup />;
      case 'Default Location Configuration':
        return <TaxLocationSetup />;
      case 'Tax Categories':
        return <TaxCategorySetup />;
      default:
        return null;
    }
  }

  useEffect(() => {
    getTabContent(tab);
  }, [tab]);

  return (
    <div className="tax-setup">
      <StickyHeader title={'Manage Taxes'} />
      <TabNav
        tabNames={['Tax Codes', 'Tax Jurisdictions', 'Default Location Configuration', 'Tax Categories']}
        onSelect={getTabContent}
      />
    </div>
  );
};
